export interface IQuest {
  title: string
  description?: string
  id: string
  isActive: boolean
  statusText: string
  items: Array<IQuestItem>
}

export enum IQuestFieldType {
  text = 'text',
  textarea = 'textarea',
  bool = 'bool',
  rating = 'rating',
  checkboxGroup = 'checkbox-group',
  radioGroup = 'radio-group'
}

export type IQuestField = {
  title: string
  name: string
  description?: string
}

export interface IQuestRatingField extends IQuestField {
  value?: number
  items: number
  type: IQuestFieldType.rating
}

export interface IQuestTextField extends IQuestField {
  value?: string
  type: IQuestFieldType.text
}

export interface IQuestTextAreaField extends IQuestField {
  value?: string
  type: IQuestFieldType.textarea
}

export interface IQuestBoolField extends IQuestField {
  value?: boolean | undefined
  type: IQuestFieldType.bool
}

export interface IQuestCheckboxGroupField extends IQuestField {
  value?: Array<string>
  options: Array<{ value: string; label: string }>
  type: IQuestFieldType.checkboxGroup
}

export interface IQuestRadioGroupField extends IQuestField {
  value?: string
  options: Array<{ value: string; label: string }>
  type: IQuestFieldType.radioGroup
}

export type IQuestItem =
  | IQuestBoolField
  | IQuestTextField
  | IQuestTextAreaField
  | IQuestRatingField
  | IQuestCheckboxGroupField
  | IQuestRadioGroupField

export const quest = (): IQuest => ({
  title: 'Название опроса',
  description:
    'Текстовое описание опроса. Нужно, чтобы помочь людям понять, что за опрос такой интересный будет. Наличие этого текста не обязательно. Если текст используется, то он может быть как в одну строку, так и в две, и в три. Не ограничивайте себя, но руководствуйтесь здравым смыслом!',
  id: '1',
  isActive: true,
  statusText: 'Запущен',
  items: [
    {
      title: 'Оцените, на сколько вы добрый человек?',
      name: 'dobrota',
      type: IQuestFieldType.rating,
      value: undefined,
      items: 5
    },
    {
      title: 'Какой предмет из детства вы помните?',
      name: 'memories',
      type: IQuestFieldType.text,
      value: ''
    },
    {
      title: 'Выберите из списка наиболее привлекающие вас тематики:',
      name: 'subjects',
      type: IQuestFieldType.checkboxGroup,
      value: [],
      options: [
        { value: 'технологии', label: 'Технологии' },
        { value: 'психология', label: 'Психология' },
        { value: 'политика', label: 'Политика' },
        { value: 'социология', label: 'Социология' }
      ]
    },
    {
      title:
        'Опишите самый запоминающийся эпизод из вашей университетской жизни:',
      name: 'universityLife',
      type: IQuestFieldType.textarea,
      value: ''
    },
    {
      title: 'Выберите из списка одну наиболее привлекающую вас тематики:',
      name: 'favoriteSubject',
      type: IQuestFieldType.radioGroup,
      value: '',
      options: [
        { value: 'технологии', label: 'Технологии' },
        { value: 'психология', label: 'Психология' },
        { value: 'политика', label: 'Политика' },
        { value: 'социология', label: 'Социология' }
      ]
    },
    {
      title:
        'Согласны ли вы с утверждением, что культура — это развитие человечества?',
      name: 'culture',
      type: IQuestFieldType.bool,
      description:
        'Ответьте на вопрос, используя только конструкции «да» или «нет».'
    }
  ]
})
